import React from 'react';
import OrganizationBasicInfoComponent from './organization-basic-info.component';
import OrganizationAddressComponent from './organization-address.component';
import OrganizationBusinessInfoComponent from './organization-business-info.component';
import OrganizationDbnieInfoComponent from './organization-dbn-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export default function OrganizationComponent({ handleFormSubmit, back, currencyCodeType, handleInnerbasicFormChange, onInnerFormChange, selectedAddress, organization }: any) {
  const tabItems = [
    {
      id: 1,
      title: 'Organization Details',
      component: <OrganizationBasicInfoComponent
        currencyCodeType={currencyCodeType}
        onInnerFormChange={onInnerFormChange}
        organization={organization} />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Address',
      component: <OrganizationAddressComponent
        handleInnerbasicFormChange={handleInnerbasicFormChange}
        onInnerFormChange={onInnerFormChange}
        organization={organization}
        selectedAddress={selectedAddress}
      />,
      isVisible: true,
    },
    {
      id: 3,
      title: 'Business',
      component: <OrganizationBusinessInfoComponent
        onInnerFormChange={onInnerFormChange}
        organization={organization}
      />,
      isVisible: true,
    },
    {
      id: 4,
      title: 'DBNIE',
      component: <OrganizationDbnieInfoComponent
        onInnerFormChange={onInnerFormChange}
        organization={organization}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  );
}

